import moment from 'moment';
export const 
    INITIAL_STATE = {
        id: 0,
        amount: 1,
        articleSerialNumber: '',
        articleAssemblyAddress:'',
        articlePurchaseDate:moment(),
        articleIsCompleted:false,
        articleHasDisassemblySigns:false,
        articleIsNecessaryForBusiness:false,
        articlePurchaseAddress:'',
        courier: {
            value: 'NotSpecified',
            displayName: ''
        },
        customerRequest: '',
        dateOfReceiptOfGoods: moment(),
        notes: '',
        faultDate: moment(),
        faultDescription: '',
        faultDiscoveryCircumstances: '',
        files: [],
        purchaseProve:[],
        invoiceQuantity: 1,
        product: {
            code: '',
            name: ''
        },
        quantityCorrectionsProposal: {
            value: 'NotSpecified',
            displayName: '',
            id:0
        },
        salesDocumentNumber: '',
        salesDocumentPosition: '',
        shipmentDescription: '',
        shippedQuantity: 1,
        termOfUse: false,
        waybillNumber: '',
        waybillCourier: {
            value: 'NotSpecified',
            displayName: ''
        },
    };


// WEBPACK FOOTER //
// ./src/reducers/state/ComplaintPosition.js